import { render } from "./offline_services.vue?vue&type=template&id=04cda8ca&scoped=true"
import script from "./offline_services.vue?vue&type=script&lang=js"
export * from "./offline_services.vue?vue&type=script&lang=js"

import "./offline_services.vue?vue&type=style&index=0&id=04cda8ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cda8ca"]])

export default __exports__